$('#agendaview select#tags').change(function () {
    $('.event_days').hide();
    $('.tagdetails').closest('li').hide();
    $('.tag_change').html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + ' fa-fw"></i> Loading events for selected category...');

    var tagsfilter = $(this).val();

    window.location = base_url + 'timetable/categories' + '/' + tagsfilter;
});

$(window).on('load', function () {
    var option = $('#tags option:selected').text();
    if (option !== '') {
        $('ul.event_days li > em').append(' for ' + '<strong>' + option + '</strong>');
    }
});
